export default {
  methods: {
    validateDataIterator(dataIteratorRef) {

      if (!dataIteratorRef) {
        return true
      }

      let isValid = true

      let iteratorFormsKeys = Object.keys(dataIteratorRef.$refs).filter(r => r.startsWith("iteratorForm_"))
      iteratorFormsKeys.forEach(key => {
        let form = dataIteratorRef.$refs[key][0]
        if (form) {
          const formValid = form.validate()
          isValid = isValid && formValid
        }
      })
      return isValid
    },
  }
}